import { Radio } from "@mantine/core";
import { RadioSurvey } from "../../../components";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <RadioSurvey
      label="¿Sabes cómo funciona el procedimiento de investigación cuando hay una denuncia por acoso?"
      {...form.getInputProps("SP_012_conoceProcesoDeInvestigacion")}
      orientation="vertical"
    >
      <Radio label={`${t("yes")}.`} value="Sí." />
      <Radio label={`${t("no")}.`} value="No." />
    </RadioSurvey>
  );
};

export default Component;
